
function initialState() {
  return {
    mobileViewName: '',
    mobileDealSheetId: 0,
    headerObj: {},
    mobileDate: 0,
    isMobileLoading: false,
    mobileEmployee: {}
  }
}

const state = initialState();

const getters = {
  mobileViewName(state){
    return state.mobileViewName;
  },
  mobileDealSheetId(state){
    return state.mobileDealSheetId;
  },
  headerObj(state){
    return state.headerObj;
  },
  mobileDate(state){
    return state.mobileDate;
  },
  isMobileLoading(state){
    return state.isMobileLoading;
  },
  mobileEmployee(state){
    return state.mobileEmployee;
  }
};

const actions = {
  setMobileView(context, view){
    context.commit('mobileViewName', view);
  },
  saveHeaderObj(context, val){
    context.commit('headerObj', val);
  },
  setMobileDate(context, val){
    context.commit('mobileDate', val);
  },
  setIsMobileLoading(context, val){
    context.commit('isMobileLoading', val);
  },
  setMobileEmployee(context, val){
    context.commit('mobileEmployee', val);
  }
};

const mutations = {
  mobileViewName(state, bool){
    state.mobileViewName = bool;
  },
  mobileDealSheetId(state, id){
    state.mobileDealSheetId = id;
  },
  headerObj(state, val){
    state.headerObj = val;
  },
  mobileDate(state, val){
    state.mobileDate = val;
  },
  isMobileLoading(state, val){
    state.isMobileLoading = val;
  },
  mobileEmployee(state, val){
    state.mobileEmployee = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};




// WEBPACK FOOTER //
// ./src/store/modules/Mobile.js